module.exports = __webpack_public_path__ + "img/41.a9c58534.jpg";